import { render, staticRenderFns } from "./videoInput.vue?vue&type=template&id=035ff823&scoped=true&lang=pug&"
import script from "./videoInput.vue?vue&type=script&lang=js&"
export * from "./videoInput.vue?vue&type=script&lang=js&"
import style0 from "./videoInput.vue?vue&type=style&index=0&id=035ff823&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035ff823",
  null
  
)

export default component.exports